module.exports = __webpack_public_path__ + "media/app/components/RatingModal/Mascot.74e42c56.svg";